import { ErrorWithViolations as r } from "./index8.mjs";
class e extends r {
}
export {
  e as UnprocessableContentError
};
